import { useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import "./toast.scss";

/** @temporary Replace with MetX design system toast once available. */
const TOAST_AUTO_HIDE_MS = 5000;

export type ToastVariant = "success" | "error";

export type ToastProps = {
  variant: ToastVariant;
  title: string;
  description?: string;
  href?: string;
  onDismiss: () => void;
};

export function Toast({ variant, title, description, href, onDismiss }: ToastProps) {
  useEffect(() => {
    const timeoutId = window.setTimeout(onDismiss, TOAST_AUTO_HIDE_MS);
    return () => window.clearTimeout(timeoutId);
  }, [onDismiss]);

  const iconName = variant === "success" ? "check" : "error_outline";
  const content = (
    <>
      <span className="marketplace-toast__icon" aria-hidden>
        <span className="material-symbols-outlined">{iconName}</span>
      </span>
      <span className="marketplace-toast__content">
        <span className="marketplace-toast__title">{title}</span>
        {description ? <span className="marketplace-toast__description">{description}</span> : null}
      </span>
    </>
  );

  return createPortal(
    href ? (
      <Link
        className={`marketplace-toast marketplace-toast--${variant}`}
        to={href}
        onClick={onDismiss}
        role="status"
        aria-live="polite"
      >
        {content}
      </Link>
    ) : (
      <div
        className={`marketplace-toast marketplace-toast--${variant}`}
        role="status"
        aria-live="polite"
        onClick={onDismiss}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            onDismiss();
          }
        }}
      >
        {content}
      </div>
    ),
    document.body,
  );
}
